<div class="pedido">
	<button mat-button (click)="openPedido()" class="pedido-btn">
		Meu Pedido
		<mat-icon class="color-white">expand_less</mat-icon>
	</button>
</div>
